import { Component, OnInit } from '@angular/core';
import { AnalyticsDataModel } from '../../../analytics/models/analytics.datamodel';
import { AnalyticsMapperService } from '../../../analytics/services/analytics.mapper.service';
import { EmitterService } from '../../../../core/utility/services/emitter.service';
import { EVENT_EMITTERS } from '../../../analytics/constants/analytics.constants';
import { LazyDropdownComponent } from '../../../widget-library/widgets/lazy-dropdown/lazy-dropdown.component';
import { AnalyticsMixpanelService } from '../../../analytics/services/analytics.mixpanel.service';

@Component({
	selector: 'app-lazy-dropdown-v2',
	templateUrl: './lazy-dropdown-v2.component.html',
	styleUrls: ['./lazy-dropdown-v2.component.css']
})
export class LazyDropdownV2Component extends LazyDropdownComponent implements OnInit {
	constructor(
		protected analyticsDataModel: AnalyticsDataModel,
		protected analyticsMapperService: AnalyticsMapperService,
		protected analyticsMixpanelService : AnalyticsMixpanelService
	) {
		super(analyticsDataModel, analyticsMapperService,analyticsMixpanelService);
	}

	onAdd(item: any): void {
		super.onAdd(item);
		// if (this.selectedItems.length > 0) {
		// 	jQuery('.ng-select.ng-select-multiple .ng-select-container .ng-value-container .ng-input').css({
		// 		display: 'none'
		// 	});
		// }
	}

	unselectAll(): void {
		super.unselectAll();
		EmitterService.get(EVENT_EMITTERS.REFRESH_DATA).emit(true);
		// jQuery('.ng-select.ng-select-multiple .ng-select-container .ng-value-container .ng-input').css({
		// 	display: 'block'
		// });
	}

	toggleAll(): void {
		super.toggleAll();
		setTimeout(() => {
			EmitterService.get(EVENT_EMITTERS.REFRESH_DATA).emit(true);
		}, 500);
	}

	onRemove(item: any): void {
		super.onRemove(item);
		// if (this.selectedItems.length === 0) {
		// 	jQuery('.ng-select.ng-select-multiple .ng-select-container .ng-value-container .ng-input').css({
		// 		display: 'block'
		// 	});
		// }
	}

	refreshData(): void {
		super.refreshData();
		// if (this.selectedItems.length === 0) {
		// 	jQuery('.ng-select.ng-select-multiple .ng-select-container .ng-value-container .ng-input').css({
		// 		display: 'block'
		// 	});
		// }
	}

	/**
	 * Passing this custom function will solve the error which was introduced by
	 * duplicate itemName in the datasource
	 * @param a item from datasource
	 * @param b selected item
	 */
	compareWithFn(a: any, b: any): boolean {
		return a.id === b.id;
	}
}
